// ============================================================================
// KOREAN TRANSLATIONS - UNITY MODULE (한국어)
// ============================================================================

export const unityTranslations = {
  title: "평화를 만드는 일치",
  author: "엠마누엘 작",
  subtitle: "각 종교에는 이유가 있으며, 우리의 경계는 과거에서 비롯됩니다",
  description: "영적 일치와 전통 간 평화에 대한 성찰 모듈",
  
  nav: {
    intro: "소개",
    religions: "종교들",
    common: "공통 기반",
    humility: "겸손"
  },

  intro: {
    emmanuelSays: "엠마누엘이 말합니다:",
    ourBordersFromPast: "우리의 경계는 과거에서 비롯됩니다",
    bordersDescription: "각 종교에는 이유가 있습니다. 우리의 분열은 신의 뜻이 아니라 역사, 지리, 문화의 결실입니다.",
    divisionWork: "분열, 두려움의 장벽과 경계를 통한 고립은 우리의 위험한 과거의 작품입니다.",
    sharedHumanity: "우리는 서로 다른 전통에서 태어났지만 같은 인류를 공유합니다.",
    
    revelationTitle: "눈을 뜨게 하는 계시",
    surprisedLearning: "어느 날 유대인도 하나님의 자녀라는 것을 알고 놀랐습니다.",
    angelMichael: "천사 미카엘이 무슬림들에게 위대한 사자라는 것을.",
    jesusNames: "예수, 이사, 예슈아가 기독교 신앙 안에서도 다양한 방식으로 알려져 있다는 것을.",
    diverseTribes: "다양한 부족, 다양한 교회, 다양한 가족들이 존재하기 때문입니다.",
    sameRealities: "우리는 다른 이름으로 같은 현실을 말하고 있습니다. 이것은 우리를 분리하는 것이 아니라 더 가까이 다가가게 해야 합니다.",
    
    respectTitle: "존중: 겸손의 토대, 평화의 수호자",
    respectFoundation: "형제애가 객관적으로 적용될 수 없다 하더라도, 존중은 겸손의 토대이며 평화의 수호자입니다.",
    understandingProcess: "다른 종교들을 이해하고 존중하는 것은 겸손의 과정입니다. 이것은 자신의 신앙을 포기하는 것이 아니라, 다른 이도 진리를 찾는다는 것을 받아들이는 것입니다.",
    
    whatBindsUs: "우리를 진정으로 묶는 것",
    seekingRelation: "모든 종교는 관계를 추구합니다. 모든 사람은 평화를 추구합니다.",
    loveOfGod: "우리 모두를 묶는 이 관계는 하나님의 사랑입니다.",
    universalLink: "사랑은 모든 경계, 모든 언어, 모든 전통을 초월하는 보편적 유대입니다.",
    
    inclusionTitle: "포용: 종교적 다양성보다 훨씬 더 광대한",
    vastInclusion: "종교적 다양성은 광대하지만, 하나님께서 부르시는 곳에 있는 다른 이들을 포용하는 것은 훨씬 더 광대합니다.",
    respectDifferences: "피부색과 성별의 차이를 존중하고 포용하는 것이 우리를 하나님께서 사랑하시는 독특한 인간으로 만듭니다.",
    jesusCommand: "예수께서 말씀하셨습니다: '서로 사랑하라.'",
    
    communitySpirit: "공동체주의 정신과 단절하기",
    communityTerror: "공동체주의는 위장된 악의 증오의 공포입니다. 그것은 신앙을 부족 정체성으로, 분리하는 벽으로, 상처를 주는 무기로 변질시킵니다.",
    pridePolitics: "우리의 당파 정신은 우리를 교만의 정치로 밀어붙입니다:",
    prideQuotes: "나는 당신을 해칠 권리가 있다. 나는 옳다 그것으로 끝이다. 나는 정당한 전쟁을 할 권리가 있다.",
    watchHeart: "문제의 핵심, 우리 자신의 악의 뿌리에 주의를 기울이십시오.",
    refuseDivision: "하나님의 이름으로 인류를 분열시키는 이 표류를 거부합시다.",
    
    freedomTitle: "자유롭기 위해, 다른 이들도 자유롭게 하라",
    freedomOthers: "자유롭기 위해서는 다른 이들도 자유롭게 만들 줄 알아야 합니다.",
    defendFreedom: "나의 믿을 자유는 모든 이의 자유를 옹호할 때만 가치가 있습니다. 다른 이를 억압하는 것은 나 자신을 종살이로 정죄하는 것입니다.",
    
    changeHeartTitle: "네 마음을 바꾸라: 진정한 등불이 되라",
    recognizeDecency: "예의범절이 각자에게 동일하지 않다는 것을 인정하십시오.",
    changeYourself: "먼저 너 자신부터 점진적으로 변화하십시오. 네 마음을 바꾸고, 네 삶을 변화시키고, 진정한 등불이 되십시오.",
    beExample: "너는 잔디밭에 오줌을 누지 말라, 그것은 죽을 것이다... 다른 이들에게 네 규칙을 강요하지 말고, 네 변화를 통해 살아있는 본보기가 되십시오.",
    
    childrenPeaceTitle: "우리 아이들은 다양성 속에서 평화롭게 살 것입니다",
    avoidPursuit: "말에 대한 말의 추적을 피하십시오.",
    peaceChoice: "오늘 존중을 선택한다면, 미래의 우리 아이들은 다양성 속에서 평화롭게 살 것입니다. 평화는 지금, 우리의 말과 행동에서 우리로부터 시작됩니다.",
    
    discernTitle: "분별하라: 인간인가 하나님인가?",
    manSpeaks: "너무나 많이, 분열시키는 것은 인간의 마음입니다.",
    seeFruits: "우리는 말과 단어의 열매로 그것을 봅니다: 도둑질, 파괴, 전쟁들. 자신의 교만을 위해 말을 조작하는 것을 조심하십시오.",
    
    lookPeaceTitle: "평화와 사랑을 바라보라",
    lookPeaceAll: "모든 이를 위한 평화를 바라보고, 다른 이들을 위한 하나님의 사랑을 바라보십시오.",
    godSpeaks: "말들이 평화, 화해, 일치를 낳을 때: 하나님께서 말씀하십니다. 말들이 분열, 증오, 전쟁을 낳을 때: 인간의 교만입니다.",
    
    watchWordsTitle: "우리의 말들을 지키라",
    watchShares: "우리의 나눔을 지키고, 다른 이들에게 해로운 우리의 반대 말들을 지키십시오.",
    disqualify: "이러한 악들은 우리 자신을 자격 상실시킵니다. 우리 말의 열매들은 누가 우리 안에서 말하는지를 드러냅니다: 하나님인가 우리 자신의 교만인가?",
    
    wisdomMaturityTitle: "우리 본성 앞에서의 지혜와 성숙",
    useScriptures: "경전들(율법들)을 사용하여 해를 끼치는 것은 우리의 습관이며, 거의 자연스럽고 장난스러운 과정입니다.",
    hateSin: "우리의 죄 많은 본성 앞에서, 우리는 악과 악을 행하는 사람들을 혐오합니다.",
    separateActs: "그러나 지혜와 성숙으로, 우리 인간 빈곤의 행위들을 분리해야 합니다.",
    compassionNature: "연민과 은혜가 필요한 우리의 동물적 본성을 인정하되, 상황에 따라 자신을 보호해야 합니다.",
    
    denounceLeadersTitle: "부패한 영적 지도자들을 고발하라",
    watchLeaders: "자신들의 타락과 부정직함을 비밀로 유지하려는 영적 지도자들이나 지도자들을 조심하십시오.",
    noJustice: "정의가 없으면 본보기도 없습니다. 지식이 없으면 우리의 침묵으로 다른 희생자들이 소멸합니다.",
    silenceComplicity: "불의 앞에서의 침묵은 공모입니다. 다른 이들을 보호하기 위해 진실이 말해져야 합니다."
  },

  religions: {
    title: "다양한 종교들, 하나의 인류",
    intro: "기독교인, 무슬림, 유대인, 힌두교도, 불교도... 그리고 많은 다른 이들: 모두가 진리를 찾습니다",
    theirGod: "그들의 하나님:",
    theGood: "선:",
    theEvil: "악:",
    theAngels: "천사들:",
    theUnity: "일치:",
    values: "가치들:",
    commonGoal: "공통 목표",
    seekingPeace: "모든 종교는 공통의 목표를 공유합니다: 평화를 추구하고, 사랑을 증진하며, 더 나은 세상을 만드는 것. 우리의 차이를 넘어, 우리는 모두 지혜와 조화를 추구하는 이 여정에서 하나로 연합되어 있습니다.",
    
    christianity: {
      name: "기독교",
      godText: "유일한 하나님, 창조주 아버지",
      goodText: "이웃 사랑, 용서, 평화",
      evilText: "증오, 이기심, 폭력",
      angelsText: "하나님의 사자들 (가브리엘, 미카엘...)",
      unityText: "모든 사람을 위한 한 분 하나님",
      values: "사랑,용서,평화,겸손,정의"
    },
    islam: {
      name: "이슬람",
      godText: "알라, 유일하시고 자비로우신 분",
      goodText: "정의, 자선, 평화",
      evilText: "억압, 거짓말, 분열",
      angelsText: "빛의 천사들 (지브릴, 미카일...)",
      unityText: "알라 외에 신은 없다",
      values: "평화,정의,자선,존중,자비"
    },
    judaism: {
      name: "유대교",
      godText: "야훼, 유일한 영원하신 분",
      goodText: "정의, 연민, 생명",
      evilText: "억압, 중상모략, 증오",
      angelsText: "천상의 사자들 (말라킴)",
      unityText: "들으라 이스라엘아, 여호와는 하나이시니라",
      values: "정의,생명,기억,평화,학습"
    },
    hinduism: {
      name: "힌두교",
      godText: "브라만, 지고의 실재",
      goodText: "비폭력(아힘사), 올바른 의무",
      evilText: "폭력, 영적 무지",
      angelsText: "데바스, 자비로운 천상의 존재들",
      unityText: "모든 것은 브라만 안에서 하나",
      values: "비폭력,진실,연민,순수,조화"
    },
    buddhism: {
      name: "불교",
      godText: "창조주 신은 없으나 신성함에 대한 존중",
      goodText: "연민, 지혜, 평화",
      evilText: "무지로 인한 고통",
      angelsText: "보살들, 깨달은 존재들",
      unityText: "각자 안의 불성",
      values: "연민,지혜,평화,비폭력,깨달음"
    }
  },

  common: {
    title: "공통 기반들",
    intro: "선, 악, 천사들, 유일한 하나님, 관계, 포용: 인류를 하나로 묶는 것",
    
    goodTitle: "선",
    goodDescription: "모든 종교는 사랑, 정의, 연민을 가르칩니다",
    goodExamples: "자신처럼 이웃을 사랑하라|차별 없이 선을 행하라|약자와 억압받는 이들을 보호하라|선의로 진실을 말하라|가진 것을 나누라",
    
    evilTitle: "악",
    evilDescription: "모든 종교가 폭력, 거짓말, 억압을 규탄합니다",
    evilExamples: "정의 없이 죽이기|훔치고 착취하기|거짓말하고 비방하기|경멸하고 굴욕주기|분열시키고 미워하기",
    
    angelsTitle: "천사들과 영적 존재들",
    angelsDescription: "거의 모든 종교가 자비로운 천상의 사자들을 인정합니다",
    angelsExamples: "하나님의 사자 천사들|영적 안내자들|빛의 존재들|천상의 보호자들|보살들과 데바스",
    
    godTitle: "유일한 하나님 (또는 지고의 실재)",
    godDescription: "대다수가 유일한 근원, 창조주 또는 궁극적 실재를 믿습니다",
    godExamples: "기독교, 이슬람, 유대교: 한 분 하나님|힌두교: 브라만, 지고의 하나|불교: 보편적 불성|모두가 궁극적 진리를 추구합니다|모두가 일치와 평화를 열망합니다",
    
    relationTitle: "관계와 평화",
    relationDescription: "모든 종교와 모든 사람을 진정으로 하나로 묶는 것",
    relationExamples: "각 종교는 신과의 관계를 추구합니다|각 사람은 평화를 추구합니다|우리 모두를 묶는 이 관계는 하나님의 사랑입니다|사랑은 보편적 유대입니다|평화는 우리의 공통된 열망입니다",
    
    inclusionTitle: "포용: 하나님의 사랑을 받는 이들",
    inclusionDescription: "종교적 다양성은 광대하지만, 포용은 훨씬 더 광대합니다",
    inclusionExamples: "하나님께서 부르시는 곳에 있는 다른 이들의 포용|피부색 차이에 대한 존중|성별 차이에 대한 존중|포용은 우리를 하나님께서 사랑하시는 독특한 인간으로 만듭니다|예수께서 말씀하셨습니다: '서로 사랑하라'",
    
    finalQuote: "어느 날 유대인들도 하나님의 자녀들이고, 천사 미카엘이 무슬림들에게 위대한 사자이며, 예수, 이사, 예슈아가 기독교 신앙 안에서도 다양한 방식으로 알려져 있다는 것을 알고 놀랐습니다. 다양한 부족들, 다양한 교회들, 다양한 가족들이 존재하기 때문입니다.",
    finalQuote2: "우리는 다른 이름들로 같은 현실들을 말하고 있습니다.",
    quoteAuthor: "엠마누엘, 평화를 만드는 일치"
  },

  humility: {
    title: "겸손과 평화를 향한 7단계",
    intro: "공동체주의를 넘어서 진정한 등불이 되기 위한 과정",
    
    step: "단계",
    action: "행동:",
    
    step1Title: "인정하라: 우리의 경계들은 과거에서 비롯된다",
    step1Description: "분열, 두려움의 장벽들과 경계들을 통한 고립은 우리의 위험한 과거의 작품입니다. 우리의 분열들은 하나님의 뜻이 아닙니다.",
    step1Action: "내 전통은 나만의 것이며, 나는 하나님께서 원하시는 다양성의 일부임을 받아들이기",
    
    step2Title: "존중: 겸손의 토대, 평화의 수호자",
    step2Description: "형제애가 객관적으로 적용될 수 없다 하더라도, 존중은 기초입니다.",
    step2Action: "모든 것을 이해하지 못하더라도 모든 믿음을 존중하기",
    
    step3Title: "판단하지 않고 이해하기",
    step3Description: "오늘날, 다른 이들을 이해하는 것은 필요한 겸손의 과정입니다.",
    step3Action: "판단 없이 다른 이들이 믿는 것을 진정으로 듣기",
    
    step4Title: "먼저 너 자신부터 변화하라: 진정한 등불이 되라",
    step4Description: "예의범절이 각자에게 동일하지 않다는 것을 인정하십시오. 점진적으로 네 마음을 바꾸고, 네 삶을 변화시키고, 진정한 빛이 되십시오.",
    step4Action: "내 규칙들을 다른 이들에게 강요하지 말고, 내 변화를 통해 살아있는 본보기가 되기",
    
    step5Title: "공동체주의 정신과 단절하기",
    step5Description: "우리의 당파 정신들은 우리를 교만의 정치로 밀어붙입니다: '나는 너를 해칠 권리가 있다, 나는 옳다 그것으로 끝이다.' 문제의 핵심, 우리 자신의 악의 뿌리에 주의를 기울이십시오.",
    step5Action: "내 공동체 안에서 분열의 담론들을 거부하기",
    
    step6Title: "자유롭기 위해, 다른 이들을 자유롭게 하라",
    step6Description: "나의 자유는 내가 다른 이들에게 부여하는 자유에 달려 있습니다.",
    step6Action: "내 것뿐만 아니라 모든 이의 양심의 자유를 옹호하기",
    
    step7Title: "말에 대한 말의 추적을 피하기",
    step7Description: "증오에 증오로, 모욕에 모욕으로 대응하지 마십시오.",
    step7Action: "우리 아이들이 다양성 속에서 평화롭게 살 수 있도록 평화를 선택하기",
    
    discernFruits: "열매들로 분별하기",
    humanHeart: "분열시키는 인간의 마음",
    lookGodLove: "하나님의 사랑을 바라보기",
    watchOurWords: "우리의 말들을 지키기",
    
    prideFruits: "인간 교만의 열매",
    prideFruitsList: "당파 정신: \"나는 옳다, 끝\"|교만의 정치: \"나는 당신에게 상처 줄 권리가 있다\"|성경을 이용해 상처 주기 (악의적 과정)|사람 자체를 미워함 (행동만이 아님)|자신의 일탈과 부정직을 숨기는 영적 지도자들|불의 앞에서 공범적 침묵|분열과 전쟁|경건함으로 위장한 증오|도둑질과 파괴|교만을 위한 조작|경멸과 폭력",
    
    godFruits: "하나님 사랑의 열매",
    godFruitsList: "지혜로 행동과 사람을 분리하기|우리의 인간적 가난함에 대한 연민|상황에 따라 자신을 보호하면서도 은혜 베풀기|다른 이들을 보호하기 위해 불의를 고발하기|용기를 가지고 진실 말하기|모두를 위한 평화|차별 없는 사랑|화해와 일치|겸손과 존중|모두를 위한 자유",
    
    finalQuote: "형제애가 객관적으로 적용 가능하지 않더라도, 존중은 겸손의 토대이며 평화의 수호자입니다. 말에 대한 말의 추적을 피하면, 미래의 우리 자녀들은 다양성 속에서 평화롭게 살 것입니다.",
    author: "엠마누엘"
  },

  footer: {
    quote: "존중은 겸손의 토대이며 평화의 수호자입니다. 오늘 존중을 선택한다면 우리 아이들은 다양성 속에서 평화롭게 살 것입니다.",
    author: "엠마누엘, 평화를 만드는 일치"
  }
};

export default unityTranslations;
